import { Outlet } from 'react-router-dom';

export default function Transactions() {
    return (
        <Outlet />
    )
}
